// extracted by mini-css-extract-plugin
module.exports = {"overlay_loader":"OverlayLoader_overlay_loader__dleJa"};